/* Impression SCDM - le bouton d ajout dit pourquoi il attend.

   POURQUOI CE FICHIER EXISTE
   --------------------------
   Le bouton « Ajouter a ma commande » etait a demi transparent quand la
   configuration n etait pas complete, mais il ne portait pas aria-disabled :
   on pouvait cliquer, et il ne se passait pratiquement rien a l ecran. Le
   client cliquait deux fois, puis partait.

   CE QUE CE FICHIER FAIT, ET RIEN D AUTRE
   ---------------------------------------
   Il ne valide RIEN. Il relit ce que scdm-vierge.js a deja calcule
   (window.SCDM_VIERGE) et l etat que le bouton porte deja (classe
   scdm-attente). Aucun prix, aucun pourcentage, aucune matiere, aucun
   minimum n est touche ici.

   Il NE BLOQUE JAMAIS le clic : aucun preventDefault, aucun
   stopPropagation. Si notre lecture etait fausse, l ajout se ferait quand
   meme, exactement comme avant.

   ON NE MET PAS disabled. Un bouton disabled ne recoit aucun clic : il ne
   pourrait donc rien expliquer. On met aria-disabled, qui previent les
   lecteurs d ecran sans couper l evenement, plus un nom accessible qui
   nomme ce qui manque.

   DEUX PIEGES RENCONTRES LE 10 SEPTEMBRE, ET COMMENT ILS SONT EVITES
   ------------------------------------------------------------------
   1. scdm-vierge.js ecoute le clic EN CAPTURE SUR LE BOUTON LUI-MEME et
      appelle stopImmediatePropagation(). Un deuxieme ecouteur pose sur le
      bouton n aurait aucune garantie de passer : l ordre depend de qui s est
      inscrit en premier, et scdm-vierge attend window.SCDM avant de
      s inscrire. On ecoute donc sur le DOCUMENT, en capture : la capture
      descend depuis la racine, donc on passe toujours avant le bouton, quel
      que soit l ordre d inscription.

   2. Quelque chose retire aria-disabled une fois pendant le chargement.
      Plutot que de chercher qui, on surveille l attribut et on le repose
      quand il manque alors que le bouton attend encore. Le compteur
      CORRECTIONS_MAX empeche toute partie de bras de fer sans fin. */

(function () {

  function texteValidation(cle, repli, params) {
    var racine = document.getElementById('scdmConfigValidationI18n');
    var texte = racine && racine.getAttribute('data-config-validation-' + cle);
    return (texte || repli).replace(/\{([a-z_]+)\}/g, function(mot, nom) {
      return params && Object.prototype.hasOwnProperty.call(params, nom) ? String(params[nom]) : mot;
    });
  }
  var bouton = document.getElementById('scdmAjouter');
  if (!bouton) return;

  var NOM = (bouton.textContent || texteValidation('add_order', 'Ajouter a ma commande')).trim();
  var CORRECTIONS_MAX = 24;
  var corrections = 0;
  var nous = false;

  /* Les styles vivent ici pour que le module reste d un seul tenant. */
  var style = document.createElement('style');
  style.textContent =
    '.scdm .scdm-manque.scdm-manque-vu{animation:scdmManqueVu 1.05s ease-out 2}' +
    '@keyframes scdmManqueVu{0%,100%{opacity:1}45%{opacity:.2}}' +
    '.scdm .scdm-cible-vue{outline:2px solid var(--cyan);outline-offset:5px;border-radius:10px}' +
    '@media (prefers-reduced-motion:reduce){.scdm .scdm-manque.scdm-manque-vu{animation:none}}';
  document.head.appendChild(style);

  function panneau() { return bouton.parentElement; }

  /* Le paragraphe « Il reste a choisir... » est ecrit par scdm-vierge.js, et
     il peut etre detruit puis reconstruit : on le cherche a chaque fois
     plutot que de le retenir. */
  function message() {
    var p = panneau() ? panneau().querySelector('.scdm-manque') : null;
    if (p && !p.id) p.id = 'scdmManqueMsg';
    return p;
  }

  function enAttente() { return bouton.classList.contains('scdm-attente'); }

  /* Le premier groupe encore vide, tel que scdm-vierge.js le voit. */
  function premierManquant() {
    var V = window.SCDM_VIERGE;
    if (!V || typeof V.manquantsCles !== 'function' || typeof V.groupes !== 'function') return null;
    var cles = V.manquantsCles() || [];
    if (!cles.length) return null;
    var groupes = V.groupes() || [];
    for (var i = 0; i < groupes.length; i++) {
      if (groupes[i].cle === cles[0]) return document.getElementById(groupes[i].hote);
    }
    return null;
  }

  /* Un groupe est parfois une grille de boutons : on vise le premier element
     qui sait recevoir le focus, sinon la grille elle-meme. */
  function aFocaliser(el) {
    if (!el) return null;
    if (/^(SELECT|INPUT|BUTTON|TEXTAREA|A)$/.test(el.tagName)) return el;
    var dedans = el.querySelector('button:not([hidden]),select,input:not([type=hidden]),a[href]');
    if (dedans) return dedans;
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    return el;
  }

  /* ON N ECRIT QUE SI LA VALEUR CHANGE. setAttribute produit un compte rendu
     de mutation MEME quand la valeur est identique : ecrire a chaque passage
     rappellerait l observateur, qui rappellerait etiqueter(), sans fin. Le
     navigateur gelait. Une seule comparaison evite toute la boucle. */
  function poser(attr, val) {
    if (val === null) {
      if (!bouton.hasAttribute(attr)) return;
      nous = true; bouton.removeAttribute(attr); nous = false;
      return;
    }
    if (bouton.getAttribute(attr) === val) return;
    nous = true; bouton.setAttribute(attr, val); nous = false;
  }

  /* Le nom accessible : le libelle du bouton, puis ce qui manque. Sans ca, un
     lecteur d ecran annonce « Ajouter a ma commande, non disponible » sans
     jamais dire pourquoi. */
  function etiqueter() {
    if (!enAttente()) {
      poser('aria-disabled', null);
      poser('aria-label', null);
      poser('aria-describedby', null);
      return;
    }
    poser('aria-disabled', 'true');
    var p = message();
    var reste = p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
    poser('aria-label', reste ? NOM + ' — ' + reste : NOM + ' — ' + texteValidation('incomplete', 'la configuration n’est pas complète.'));
    if (p) poser('aria-describedby', p.id);
  }

  /* Le clic quand il manque quelque chose : on montre le message, on amene
     l ecran sur le premier groupe a remplir et on y pose le focus.

     Sur le DOCUMENT et en capture : voir le piege 1 en tete de fichier. Le
     delai de 140 ms laisse passer le defilement que scdm-vierge.js fait de
     son cote vers le message, pour que le notre soit le dernier mot. */
  document.addEventListener('click', function (e) {
    var sur = (e.target && e.target.closest) ? e.target.closest('#scdmAjouter') : null;
    if (!sur || !enAttente()) return;

    var p = message();
    if (p) {
      if (p.getAttribute('role') !== 'status') p.setAttribute('role', 'status');
      if (p.getAttribute('aria-live') !== 'polite') p.setAttribute('aria-live', 'polite');
      p.classList.remove('scdm-manque-vu');
      void p.offsetWidth;
      p.classList.add('scdm-manque-vu');
      setTimeout(function () { p.classList.remove('scdm-manque-vu'); }, 2400);
    }

    var cible = aFocaliser(premierManquant());
    /* Aucun groupe ne manque : c est donc le visuel. On renvoie au depot. */
    if (!cible) {
      var drop = document.getElementById('scdmDrop');
      if (drop && !drop.classList.contains('hide')) cible = aFocaliser(drop);
    }

    setTimeout(function () {
      var vers = cible || p;
      if (vers && vers.scrollIntoView) vers.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (!cible) return;
      var enveloppe = (cible.closest && cible.closest('.fld')) || cible;
      enveloppe.classList.add('scdm-cible-vue');
      setTimeout(function () { enveloppe.classList.remove('scdm-cible-vue'); }, 2600);
      setTimeout(function () {
        try { cible.focus({ preventScroll: true }); } catch (err) { cible.focus(); }
      }, 260);
    }, 140);
  }, true);

  etiqueter();

  /* La classe scdm-attente est posee et retiree par scdm-vierge.js ; le texte
     du message change quand un groupe se remplit ; et aria-disabled peut
     disparaitre sous nos pieds (piege 2). On se recale sur les trois plutot
     que de recalculer quoi que ce soit. */
  if (window.MutationObserver) {
    new MutationObserver(function (liste) {
      if (nous) return;
      for (var i = 0; i < liste.length; i++) {
        if (liste[i].attributeName === 'aria-disabled') {
          if (!enAttente() || bouton.getAttribute('aria-disabled') === 'true') continue;
          if (corrections >= CORRECTIONS_MAX) continue;
          corrections++;
        }
      }
      etiqueter();
    }).observe(bouton, { attributes: true, attributeFilter: ['class', 'aria-disabled'] });

    var hote = panneau();
    if (hote) new MutationObserver(function () { if (!nous) etiqueter(); })
      .observe(hote, { childList: true, subtree: true, characterData: true });
  }

  /* Filet : les autres modules finissent de s installer apres nous. */
  var passages = 0;
  var minuteur = setInterval(function () {
    etiqueter();
    if (++passages >= 16) clearInterval(minuteur);
  }, 250);
  window.addEventListener('load', etiqueter);
})();
